import { render, staticRenderFns } from "./LaboratoriesList.vue?vue&type=template&id=fc4dc02a&"
import script from "./LaboratoriesList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LaboratoriesList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc4dc02a')) {
      api.createRecord('fc4dc02a', component.options)
    } else {
      api.reload('fc4dc02a', component.options)
    }
    module.hot.accept("./LaboratoriesList.vue?vue&type=template&id=fc4dc02a&", function () {
      api.rerender('fc4dc02a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/components/LaboratoriesList/LaboratoriesList.vue"
export default component.exports